export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11014.0ad9d0e4.jpg";